// Reads the session saved by the login page (see pages/login.js).
export const getSession = () => {
    try {
        return JSON.parse(localStorage.getItem('credentials')) || null;
    } catch {
        return null;
    }
};

export const hasSession = () => {
    const session = getSession();
    return Boolean(session?.user_id && session?.login_token);
};

// Display preferences that survive logout; everything else (credentials, cached data) is cleared
const KEEP_ON_LOGOUT = ['theme', 'ui.sidebarCollapsed'];

export const clearSession = () => {
    try {
        const kept = KEEP_ON_LOGOUT.map((key) => [key, localStorage.getItem(key)]);
        localStorage.clear();
        kept.forEach(([key, value]) => value !== null && localStorage.setItem(key, value));
        sessionStorage.clear();
    } catch {
        // storage unavailable: nothing to clear
    }
};
